module.exports = __webpack_public_path__ + "static/media/YF54_1.14d10026.jpg";